<template>
  <div id="app">
    <QrScanner />
  </div>
</template>

<script>
import QrScanner from "@/components/QrScanner.vue";

export default {
  components: {
    QrScanner,
  },
};
</script>